<script setup lang="ts">
  import { useMainHeaderStore } from '@/components/main-header/store'
  import type { IHeaderProfile, INavigation, ITopBarData } from '@/components/main-header/types'

  const { isDesktop } = useBTBreakpoints()

  const { locale } = useI18n()

  const { data, error } = await useFetch<ITopBarData>('/api/storyblok/topbar', {
    query: { language: locale.value }
  })

  const mainHeaderStore = useMainHeaderStore()

  const { logo } = storeToRefs(mainHeaderStore)

  const navigation = ref<INavigation[] | null>(null)
  const profile = ref<IHeaderProfile | null>(null)

  if (!error.value) {
    mainHeaderStore.logo = data.value?.logo ? data.value.logo : null
    navigation.value = data.value?.navigation ? data.value.navigation : null
    profile.value = data.value?.profile ? data.value.profile : null
  }

  const showComponent = (component: string) => {
    if (component === 'header-search') {
      return isDesktop.value
    }

    return true
  }
</script>

<template>
  <div class="container flex items-center justify-between border-b border-divider p-0">
    <div class="ml-2 flex items-center gap-2 md:m-0">
      <button
        v-if="!isDesktop"
        class="flex size-10 items-center justify-center"
        :aria-label="$t('aria.label.hamburgerMenu')"
        type="button"
        @click="mainHeaderStore.isMenuOpen = true"
      >
        <Icon name="common/menu-burger" />
      </button>
      <MainHeaderLogo
        v-if="logo"
        :logo="logo"
      />
    </div>
    <div class="flex items-center justify-end sm:mr-2 sm:gap-4 md:m-0 md:gap-5">
      <div class="flex items-center gap-1 sm:gap-4">
        <template
          v-for="(item, itemIndex) in navigation"
          :key="`${item.component}_${itemIndex}`"
        >
          <component
            :is="item.component"
            v-if="showComponent(item.component)"
            :item="item"
          />
        </template>
      </div>

      <HeaderProfile
        v-if="profile"
        :profile="profile"
      />
    </div>
  </div>
</template>
